import React from "react";
import { Card, Container, Row, Col } from "react-bootstrap";
import { useLanguage } from "../LanguageContext";

const Impressum = () => {
    const { translations } = useLanguage();

    return (
        <Card className="section-card">
            <Card.Body>

                {/* Titel */}
                <h1>{translations.impressum.title}</h1>

                {/* Inhalt – kontrollierter Abstand */}
                <Container

                >
                    <Row>
                        <Col>
                            <p><strong>{translations.impressum.operator}:</strong></p>
                            <p>
                                Patrick de Benedetto Freisinger<br />
                                PDBF-Records
                            </p>

                            <p><strong>{translations.impressum.address}:</strong></p>
                            <p>
                                Birkenweg 11<br />
                                8051 Thal<br />
                                Austria
                            </p>

                            <p><strong>{translations.impressum.contact}:</strong></p>
                            <p>
                                {translations.impressum.email}:{" "}
                                <a href="mailto:office@pdbf-records.com">
                                    office@pdbf-records.com
                                </a>
                            </p>

                            <p><strong>{translations.impressum.uid}:</strong></p>
                            <p>ATU 76279279</p>

                            <p><strong>{translations.impressum.business}:</strong></p>
                            <p>{translations.impressum.businessText}</p>

                            {translations.impressum.disclaimer && (
                                <p
                                    style={{
                                        marginTop: "1.25rem",
                                        fontStyle: "italic",
                                        opacity: 0.85
                                    }}
                                >
                                    {translations.impressum.disclaimer}
                                </p>
                            )}
                        </Col>
                    </Row>
                </Container>

            </Card.Body>
        </Card>
    );
};

export default Impressum;
